<!-- TEMPORARY nav-migration directory. Remove when the new navigation fully covers every page. -->
<div class="all-pages">
  <div class="ap-head">
    <h1>All pages — {{ roleLabel }} <span class="ap-tag">temporary directory</span></h1>
    <p>
      Every page for your role in one place, so nothing is unreachable while we rebuild the navigation.
      Detail links use a live sample id (your first artwork / gallery). Items marked
      <em>“open from …”</em> are reached through their list page.
    </p>
  </div>

  @if (!loaded) {
    <div class="ap-loading"><i class="fa fa-spinner fa-spin"></i> Loading sample links…</div>
  } @else {
    <div class="ap-grid">
      @for (g of groups; track g.title) {
        <section class="ap-card">
          <h2><i [class]="g.icon"></i> {{ g.title }}</h2>
          <ul>
            @for (l of g.links; track l.label) {
              <li>
                @if (!l.disabled) {
                  <a [routerLink]="l.path">{{ l.label }}</a>
                } @else {
                  <span class="ap-disabled">{{ l.label }}</span>
                }
                @if (l.note) { <small class="ap-note">{{ l.note }}</small> }
              </li>
            }
          </ul>
        </section>
      }
    </div>
  }
</div>
